import styled from 'styled-components'

export const Attribution = styled.div`
    display: flex;
    font-weight: bold;
    margin-bottom: 16px;
`

export const Username = styled.a`
    color: inherit;
    cursor: pointer;
    text-decoration: none;

    &:hover {
        color: inherit;
    }

    svg {
        display: inline-block;
        height: 14px;
        vertical-align: middle;
        width: 14px;
    }
`

export const Timestamp = styled.span`
    &:before {
        content: ' • ';
        display: inline-block;
        margin: 0 8px;
        opacity: 0.5;
    }
`
